// Single SDK entry point for the firebase provider.
//
// Resolves the memoized lazy `getDb` from src/lib/firebase.js. The provider
// modules import `getDb` from here and call it at CALL TIME (never at module
// top level), so importing any firebase provider module has no side effects:
// a Supabase-only build can statically import this provider without
// constructing a Firestore app or throwing on missing VITE_FIREBASE_* env.
//
// Resilience for the existing test suite: many tests mock `../../lib/firebase`
// to expose only a `db` export (not `getDb`). We fall back to that `db` when
// `getDb` isn't present, so those mocks keep working without edits while real
// code uses the lazy getDb. See docs/features/supabase/.
import * as fb from '../../firebase.js';

export function getDb() {
  // Access defensively: a Vitest mock namespace THROWS on reading an export it
  // didn't define (rather than returning undefined), so a test exposing only
  // `db` would blow up on `fb.getDb`. Try getDb first, fall back to db.
  let getter;
  try {
    getter = fb.getDb;
  } catch {
    getter = undefined;
  }
  return typeof getter === 'function' ? getter() : fb.db;
}
